export enum SuggestionTypeAnalytics {
  jobTitle = 'position',
  workExperiences = 'workExperience',
}
